<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12>
        <v-layout row wrap>
          <h1 class="font-weight-bold">{{ web.name }}</h1>
        </v-layout>
      </v-flex>
      <v-divider></v-divider>

      <v-layout row wrap>
        <v-flex xs12 sm9 md9 lg9>
          <v-card dark color="twhite" class="black--text">
            <v-flex>
              <v-img
                :src="web.imgUrl"
                :srcset="web.altImg"
                fill-height
                contain
                aspect-ratio="1.7"
              >
              </v-img>
            </v-flex>
            <v-layout>
              <v-flex ma-2 pa-2>
                <h4 class="font-weight-regular subheading text-md-center">
                  {{ web.description }}
                </h4>
                <v-flex ma-0 pa-2>
                  <h3 class="font-weight-bold title text-md-left">Features</h3>
                  <v-flex ma-3 pa-0>
                    <h4
                      class="font-weight-regular subheading text-md-left"
                      v-html="web.features"
                    ></h4>
                  </v-flex>
                </v-flex>
              </v-flex>
            </v-layout>
            <h3 class="font-weight-bold title">Tags</h3>
            <v-layout row wrap>
              <v-flex>
                <v-chip class="accent">{{ web.tags }}</v-chip>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <v-flex xs12 sm6 md4 lg3>
          <v-card>
            <v-flex ma-0 pa-2 v-if="web.price != 0">
              <v-flex ma-0 pa-2>
                <h4 class="font-weight-bold subheading">
                  Price:
                </h4>
                <h3
                  class="font-weight-bold subheading error--text"
                  v-if="$store.state.currency == 'INR'"
                >
                  {{ $store.state.currencySymbol }} {{ web.INR }}
                </h3>
                <h3 class="font-weight-bold subheading error--text" v-else>
                  {{ $store.state.currencySymbol }} {{ web.USD }}
                </h3>
              </v-flex>
              <v-btn
                class="rounded-card"
                block
                color="primary"
                :to="{
                  name: 'serviceform',
                  params: { web: web }
                }"
                >Place Order</v-btn
              >

              <v-flex ma-0 pa-2>
                <h4 class="font-weight-regular subheading">
                  Still have any doubts ? <a href="/contactus">Talk</a> to us
                  for more.
                </h4>
              </v-flex>
            </v-flex>
            <v-flex ma-0 pa-2 v-else>
              <v-btn
                class="rounded-card"
                block
                color="primary"
                :to="{
                  name: 'contactus',
                  params: { web: web }
                }"
                >Contact Us</v-btn
              >
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import serviceData from "@/services";
export default {
  name: "ServiceTemplateDetails",
  data: () => ({
    name: "",
    id: "",
    demoUrl: "",
    description: "",
    features: "",
    temp: [],
    isBookMarked: false
  }),
  props: {
    web: {
      type: Object
    }
  },
  mounted() {
    if (this.$route.query.id == null)
      window.location.href = "/explore-services";
    else {
      if (this.web == null) {
        //if web parameter isnt passed fetch from url
        this.wid = this.$route.query.id;
        this.wname = this.$route.query.name;
        this.wserviceType = this.$route.query.wserviceType;
        this.temp = serviceData;
        let i = 0;
        //look for id in the json and then save it in web
        for (i = 0; i < this.temp.length; i++) {
          if (this.temp[i].id == this.wid) {
            this.web = this.temp[i];
            break;
          }
        }
      }
    }
  }
};
</script>
<style>
.rounded-card {
  border-radius: 50px;
}
</style>
